import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SideMenu from "./SideMenu";
const CartOverlay = ({ isOpen, toggleCartOverlay, }) => {
    return (_jsxs("div", { className: `fixed inset-0 z-50 transition-transform transform ${isOpen ? "translate-x-0" : "translate-x-full"}`, children: [_jsx("div", { className: "absolute inset-0 bg-black bg-opacity-50", onClick: toggleCartOverlay }), _jsx("div", { className: "absolute right-0 h-full", children: _jsx(SideMenu, { isOpen: isOpen, toggleCartOverlay: toggleCartOverlay }) })] }));
};
export default CartOverlay;
